export default "__VITE_ASSET__IfXZsUTz__"